import { TransmissionRunBatchItemSummaryEntity } from 'src/store/transmission-run-batch-item-summary/transmission-run-batch-item-summary.model';
import { PrdProcessingState } from './pilot-view-model';

export class TransmissionRunBatchItemSummaryViewModel
  implements TransmissionRunBatchItemSummaryEntity {
  public id: string;
  public transmissionRunBatchId: string;
  public transmissionRunId: string;
  public pilotId: string;
  public pilotFirstName: string;
  public pilotMiddleName?: string;
  public pilotLastName: string;
  public processingState?: PrdProcessingState | undefined;
  public entityTypeId: number;
  public entityTypeName: string;
  public entityId: string;
  public hasError: boolean;
  public isProcessed: boolean;
  public prdProcessedDate?: Date | undefined;
  public errorDescription?: string | undefined;
  public publishedDate?: Date | undefined;
  public processedDate?: Date | undefined;

  constructor(transmissionRunBatchItemSummary: TransmissionRunBatchItemSummaryEntity) {
    Object.assign(this, transmissionRunBatchItemSummary);
  }
}
